import { baseUrl, extendHeaders, headers } from "./HelpService";

const PageUrl = baseUrl + 'fee_auditors/';

const getFeeAuditors = (accountId: number): Promise<Response | null> => {
    return fetch(`${PageUrl}getFeeAuditors/?account_id=${encodeURIComponent(accountId)}`, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const updateDimensionInDB = (dimensions): Promise<Response | null> => {
    return fetch(PageUrl + "updateDimensions/", {
        method: "PUT",
        headers: extendHeaders(),
        body: JSON.stringify(dimensions)
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};

const importDimensionsExcel = (accountId, file): Promise<Response | null> => {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("account_id", accountId);
    return fetch(PageUrl + "importDimensionsExcel/", {
        method: "POST",
        headers: headers(),
        body: formData
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};


const importDangerousGoodsExcel = (accountId, file): Promise<Response | null> => {
    let formData = new FormData();
    formData.append("dangerous_goods_file", file);
    formData.append("account_id", accountId);
    return fetch(PageUrl + "importDangerousGoodsExcel/", {
        method: "PUT",
        headers: headers(),
        body: formData
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};


const FeeAuditorsService = {
    getFeeAuditors,
    updateDimensionInDB,
    importDimensionsExcel,
    importDangerousGoodsExcel
};

export default FeeAuditorsService;
